export const BASE_URL = "https://api-ai-document-analyzer.metafic.co";

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const FILE_CATEGORY = {
  it: "Public tenders for IT services provision",
  distribution: "Public tenders for distribution and leasing services",
  general: "General tenders",
};

export const PROMPT_TYPES = {
  // General prompts
  "Category Prompt": "category_prompt",
  "Summary Prompt": "summary_prompt",
  "Metadata Prompt": "metadata_prompt",
  "Metadata Document For Customer Prompt": "metadata_document_for_customer_prompt",
  "Metadata Document Reference Prompt": "metadata_document_reference_prompt",
  
  // Distribution and Leasing Services (C1) Analysis Prompts
  "Distribution and Leasing Services Analysis - Signing The Contract": "analysis_signing_the_contract_prompt",
  "Distribution and Leasing Services Analysis - Validity": "analysis_validity_prompt",
  "Distribution and Leasing Services Analysis - Extension": "analysis_extension_prompt",
  "Distribution and Leasing Services Analysis - Renewal": "analysis_renewal_prompt",
  "Distribution and Leasing Services Analysis - Annual Adjustment": "analysis_annual_adjustment_prompt",
  "Distribution and Leasing Services Analysis - Subcontracting": "analysis_subcontracting_prompt",
  
  // Distribution and Leasing Services (C1) Comments Prompts
  "Distribution and Leasing Services Comments - Budget Available": "comments_budget_available_prompt",
  "Distribution and Leasing Services Comments - Guarantee of Seriousness Offer": "comments_guarantee_of_seriousness_offer_prompt",
  "Distribution and Leasing Services Comments - Guarantee of Faithful Compliance": "comments_guarantee_of_faithful_compliance_prompt",
  "Distribution and Leasing Services Comments - Fines": "comments_fines_prompt",
  "Distribution and Leasing Services Comments - Early Termination": "comments_early_termination_prompt",
  "Distribution and Leasing Services Comments - Pay": "comments_pay_prompt",
  
  // Distribution and Leasing Services (C1) Technical Comments Prompts
  "Distribution and Leasing Services Technical Comments - Applicable Standards": "technical_comments_applicable_standards_prompt",
  "Distribution and Leasing Services Technical Comments - Required Resources": "technical_comments_required_resources_prompt",
  "Distribution and Leasing Services Technical Comments - Trainings": "technical_comments_trainings_prompt",
  "Distribution and Leasing Services Technical Comments - Average Monthly Consumption": "technical_comments_average_monthly_consumption_prompt",
  "Distribution and Leasing Services Technical Comments - Emergency Service": "technical_comments_emergency_service_prompt",
  "Distribution and Leasing Services Technical Comments - Corrective Maintenance": "technical_comments_corrective_maintenance_prompt",
  
  // IT Services and Provision (C2) Analysis Prompts
  "IT Services and Provision Analysis - Subscription of The Contract": "c2_analysis_subscription_of_the_contract_prompt",
  "IT Services and Provision Analysis - Validity": "c2_analysis_validity_prompt",
  "IT Services and Provision Analysis - Renewal": "c2_analysis_renewal_prompt",
  "IT Services and Provision Analysis - Extension": "c2_analysis_extension_prompt",
  "IT Services and Provision Analysis - Subcontracting": "c2_analysis_subcontracting_prompt",
  "IT Services and Provision Analysis - Re-adjustability": "c2_analysis_re_adjustability_prompt",
  "IT Services and Provision Analysis - Price": "c2_analysis_price_prompt",
  "IT Services and Provision Analysis - Intellectual Property": "c2_analysis_intellectual_property_prompt",
  "IT Services and Provision Analysis - Deadlines": "c2_analysis_deadlines_prompt",
  
  // IT Services and Provision (C2) Comments Prompts
  "IT Services and Provision Comments - Estimated Contract Amount": "c2_comments_estimated_contract_amount_prompt",
  "IT Services and Provision Comments - Guarantees": "c2_comments_guarantees_prompt",
  "IT Services and Provision Comments - Offer Validity": "c2_comments_offer_validity_prompt",
  "IT Services and Provision Comments - Scope": "c2_comments_scope_prompt",
  "IT Services and Provision Comments - Evaluation Criteria": "c2_comments_evaluation_criteria_prompt",
  "IT Services and Provision Comments - Termination of Contract": "c2_comments_termination_of_contract_prompt",
  "IT Services and Provision Comments - Confidentiality": "c2_comments_confidentiality_prompt",
  "IT Services and Provision Comments - Payment Term": "c2_comments_payment_term_prompt",
  "IT Services and Provision Comments - Budget Modification": "c2_comments_budget_modification_prompt",
  "IT Services and Provision Comments - Fines": "c2_comments_fines_prompt",
  "IT Services and Provision Comments - Presentation of Warranty": "c2_comments_presentation_of_warranty_prompt",
  "IT Services and Provision Comments - Extension of Contract Term": "c2_comments_extension_of_the_contract_term_prompt",
  "IT Services and Provision Comments - Early Termination": "c2_comments_early_termination_prompt",
  "IT Services and Provision Comments - Outsourcing": "c2_comments_outsourcing_prompt",
  "IT Services and Provision Comments - Method of Payment": "c2_comments_method_of_payment_prompt",
  "IT Services and Provision Comments - Information Security": "c2_comments_information_security_prompt",
  "IT Services and Provision Comments - Ownership of Information": "c2_comments_ownership_of_information_prompt",
  
  // IT Services and Provision (C2) Technical Comments Prompts
  "IT Services and Provision Technical Comments - Technical Requirements": "c2_technical_comments_technical_requirements_prompt",
  "IT Services and Provision Technical Comments - Training Plan": "c2_technical_comments_training_plan_prompt",
  "IT Services and Provision Technical Comments - Maintenance": "c2_technical_comments_maintenance_prompt",
  "IT Services and Provision Technical Comments - Execution Deadlines": "c2_technical_comments_execution_deadlines_prompt",
  "IT Services and Provision Technical Comments - Staff Required": "c2_technical_comments_staff_required_prompt",
  
  // General Tender (C3) Analysis Prompts
  "General Tender Analysis - Renewal": "c3_analysis_renewal_prompt",
  "General Tender Analysis - Extension": "c3_analysis_extension_prompt",
  "General Tender Analysis - Subcontracting": "c3_analysis_subcontracting_prompt",
  "General Tender Analysis - Re-adjustability": "c3_analysis_re_adjustability_prompt",
  "General Tender Analysis - Price": "c3_analysis_price_prompt",
  "General Tender Analysis - Intellectual Property": "c3_analysis_intellectual_property_prompt",
  "General Tender Analysis - Deadlines": "c3_analysis_deadlines_prompt",
  
  // General Tender (C3) Comments Prompts
  "General Tender Comments - Guarantee of Seriousness Offer": "c3_comments_guarantee_of_seriousness_offer_prompt",
  "General Tender Comments - Offer Validity": "c3_comments_offer_validity_prompt",
  "General Tender Comments - Scope": "c3_comments_scope_prompt",
  "General Tender Comments - Termination of Contract": "c3_comments_termination_of_contract_prompt",
  "General Tender Comments - Confidentiality": "c3_comments_confidentiality_prompt",
  "General Tender Comments - Payment Term": "c3_comments_payment_term_prompt",
  "General Tender Comments - Fines": "c3_comments_fines_prompt",
  "General Tender Comments - Extension of Contract Term": "c3_comments_extension_of_the_contract_term_prompt",
  "General Tender Comments - Early Termination": "c3_comments_early_termination_prompt",
  "General Tender Comments - Outsourcing": "c3_comments_outsourcing_prompt",
  "General Tender Comments - Method of Payment": "c3_comments_method_of_payment_prompt",
  "General Tender Comments - Information Security": "c3_comments_information_security_prompt",
  "General Tender Comments - Ownership of Information": "c3_comments_ownership_of_information_prompt",
  
  // General Tender (C3) Technical Comments Prompts
  "General Tender Technical Comments - Technical Requirements": "c3_technical_comments_technical_requirements_prompt",
  "General Tender Technical Comments - Maintenance": "c3_technical_comments_maintenance_prompt",
  "General Tender Technical Comments - Execution Deadlines": "c3_technical_comments_execution_deadlines_prompt",
  "General Tender Technical Comments - Staff Required": "c3_technical_comments_staff_required_prompt",
  
  // Legacy/general prompts (kept for backward compatibility)
  "Distribution and Leasing Services Analysis Prompt": "analysis_prompt",
  "Distribution and Leasing Services Comments Prompt": "comments_prompt",
  "Distribution and Leasing Services Technical Comments Prompt": "technical_comments_prompt",
  "IT Services and Provision Analysis Prompt": "c2_analysis_prompt",
  "IT Services and Provision Comments Prompt": "c2_comments_prompt",
  "IT Services and Provision Technical Comments Prompt": "c2_technical_comments_prompt",
  "General Tender Analysis Prompt": "c3_analysis_prompt",
  "General Tender Comments Prompt": "c3_comments_prompt",
  "General Tender Technical Comments Prompt": "c3_technical_comments_prompt",
};
